import styled from '@emotion/styled';
import { FieldContainer, FieldEmotion } from '../Input/styles';
import { HintSkin } from '../Hint/styles';

export const FieldGroup = styled('div')`
  ${FieldContainer} {
    &:not(:first-of-type) {
      ${FieldEmotion} {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    &:not(:last-child) {
      ${FieldEmotion},
      ${HintSkin} {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    & + ${FieldContainer} {
      margin-top: -1px !important;
    }
  }

  & + &,
  & + ${FieldContainer} {
    margin-top: 2rem;
  }
`;
